import { Avatar, Box, Button, Hidden, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useRef } from 'react'

const UserBoxText = styled(Box)(
  ({ theme }) => `
        text-align: left;
        padding-left: ${theme.spacing(1)};
`
)

const UserBoxLabel = styled(Typography)(
  ({ theme }) => `
        font-weight: ${theme.typography.fontWeightBold};
        color: #ff367f;
        font-size: 1rem;
        display: block;
`
)

const UserBoxButton = styled(Button)(
  ({ theme }) => `
        padding-left: ${theme.spacing(1)};
        padding-right: ${theme.spacing(1)};

`
)

const Logo = (): JSX.Element => {
  const ref = useRef<any>(null)
  const user = {
    name: 'Blast Beam',
    avatar: 'src/images/rocket-logo.svg',
    jobtitle: 'BlastBeam'
  }

  return (
    <UserBoxButton color="secondary" ref={ref} size={'large'}>
      <Avatar
        sx={{ width: 64, height: 'auto' }}
        variant="rounded"
        alt={user.name}
        src={'/static/images/overview/rocket-logo.svg'}
      />
      <Hidden mdDown>
        <UserBoxText>
          <UserBoxLabel sx={{fontSize: 23 }} variant="h1">
            {user.name}
          </UserBoxLabel>
        </UserBoxText>
      </Hidden>
    </UserBoxButton>
  )
}

export default Logo
